import React from 'react';
import { Box } from '@mui/material';

const DraggableDivider = ({ onDrag }) => {
  const handleMouseDown = (e) => {
    e.preventDefault();
    const startX = e.clientX;
    
    const handleMouseMove = (e) => {
      const diff = e.clientX - startX;
      onDrag(diff);
    };

    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      document.body.style.cursor = 'default';
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
    document.body.style.cursor = 'col-resize';
  };

  return (
    <Box
      sx={{
        width: '4px',
        backgroundColor: 'divider',
        cursor: 'col-resize',
        transition: 'background-color 0.2s',
        '&:hover': {
          backgroundColor: 'primary.main',
          width: '6px'
        },
        '&:active': {
          backgroundColor: 'primary.dark',
          width: '6px'
        },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
      onMouseDown={handleMouseDown}
    >
      <Box
        sx={{
          height: '50px',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-around',
          alignItems: 'center',
          '& > span': {
            width: '2px',
            height: '2px',
            backgroundColor: 'grey.500',
            borderRadius: '50%'
          }
        }}
      >
        <span />
        <span />
        <span />
      </Box>
    </Box>
  );
};

export default DraggableDivider; 